/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Article,
  ArticleListParams,
  Pagination,
  ArticleCreationParams
} from '~core/models/core.models';
import { ApiConstantsService } from './api-constants.service';

@Injectable()
export class ArticleService {
  protected _httpClient = inject(HttpClient);
  protected _apiConstantsService = inject(ApiConstantsService);

  read(articleId: string): Observable<Article> {
    return this._httpClient.get<Article>(
      `${this._apiConstantsService.articleUrl}/${articleId}`
    );
  }

  list(params?: ArticleListParams): Observable<Pagination<Article>> {
    return this._httpClient.get<Pagination<Article>>(
      this._apiConstantsService.articleUrl,
      {
        params: {
          ...params,
          sort: (params as any)?.sort || 'createdAt',
          desc: (params as any)?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  create(data: ArticleCreationParams): Observable<Article> {
    return this._httpClient.post<Article>(
      this._apiConstantsService.articleUrl,
      data
    );
  }

  update(
    articleId: string,
    data: Partial<ArticleCreationParams>
  ): Observable<Article> {
    return this._httpClient.patch<Article>(
      `${this._apiConstantsService.articleUrl}/${articleId}`,
      data
    );
  }

  delete(articleId: string): Observable<unknown> {
    return this._httpClient.delete(
      `${this._apiConstantsService.articleUrl}/${articleId}`
    );
  }
}
